<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>资金管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/direct_score_list')">直属小煜明细列表</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >
          <el-form-item label='代理信息'>
            <el-input
              style="width:500px"
              v-model="filters.title"
              placeholder="请输入姓名或者手机号"
            >

            </el-input>
          </el-form-item>

          <el-form-item label="查询月份">
            <el-date-picker
              type="month"
              placeholder="选择年月"
              v-model="filters.endTime"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>

          <!-- <el-form-item label="查询时间">
            <el-form-item prop="startTime">
              <el-date-picker
                type="date"
                placeholder="选择开始日期"
                v-model="filters.startTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
            <span style="display: inline-block;margin-right: 9px;">-</span>
            <el-form-item prop="endTime">
              <el-date-picker
                type="date"
                placeholder="选择结束日期"
                v-model="filters.endTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>

          </el-form-item> -->

          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >搜索</el-button>

          </el-form-item>

        </el-form>
      </div>

      <div class="contain_body">
        <!-- <div class="contain_body_head">
          总金额：{{totalMoney}}
        </div> -->
        <el-table
          v-loading="listLoading"
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >
          <el-table-column
            prop="username"
            label="代理姓名"
          >

          </el-table-column>

          <el-table-column
            prop="telephone"
            label="代理手机号"
          >

          </el-table-column>

          <el-table-column
            prop="score"
            label="积分"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.second_type == 1">+{{scope.row.score}}</span>
              <span v-if="scope.row.second_type == 4">-{{scope.row.score}}</span>
              <span v-if="scope.row.second_type == 5">+{{scope.row.score}}</span>
              <span v-if="scope.row.second_type == 6">+{{scope.row.score}}</span>
              <span v-if="scope.row.second_type == 7">-{{scope.row.score}}</span>
              <span v-if="scope.row.second_type == 8">-{{scope.row.score}}</span>
              <span v-if="scope.row.second_type == 9">+{{scope.row.score}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="username"
            label="类型"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.second_type == 1">直属下单返利</span>
              <span v-if="scope.row.second_type == 4">提现转出直属</span>
              <span v-if="scope.row.second_type == 5">月度业绩提成获得团队小煜</span>
              <span v-if="scope.row.second_type == 6">下级转入团队小煜</span>
              <span v-if="scope.row.second_type == 7">转出给上级团队小煜</span>
              <span v-if="scope.row.second_type == 8">提现转出团队小煜</span>
              <span v-if="scope.row.second_type == 9">非直属下单返利</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="total_money"
            width="500"
            label="描述"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.second_type == 1">
                获得来自下级{{scope.row.by_name}}下的订单<span>{{scope.row.order_code}}</span>获得直属返利，比例是{{scope.row.sale_rate}}
              </div>
              <div v-if="scope.row.second_type == 9">
                获得来自下下级{{scope.row.by_name}}下的订单<span>{{scope.row.order_code}}</span>获得非直属返利，比例是{{scope.row.sale_rate}}
              </div>
              <div v-if="scope.row.second_type == 4">
                提现直属小煜：{{scope.row.score}}
                <div v-if="scope.row.info_type == 1">银行：<br />银行名称：{{scope.row.bank_name}}<br />开户行：{{scope.row.open_bank}}<br />卡号：{{scope.row.bank_code}}<br />{{scope.row.bank_username}}</div>
                <div v-if="scope.row.info_type == 2">支付宝：<br />真实姓名：{{scope.row.zhi_name}}<br />帐号：{{scope.row.zhi_account}}<br /></div>
              </div>
              <div v-if="scope.row.second_type == 5">
                {{scope.row.create_time_month}}的月度返利是：{{scope.row.score}}，公式如下：
                <div>
                  销售业绩：{{scope.row.sale_money}} * 提成比例：{{scope.row.sale_rate}} - 下级返利:{{scope.row.other_money}}<br />
                  <div v-if="scope.row.other_info != null && scope.row.other_info != ''">
                    <div
                      v-for="item in scope.row.other_info"
                      v-bind:key='item'
                    >
                      <span>{{item.username}}获得收益：{{item.money}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <span v-if="scope.row.second_type == 6">来自下级{{scope.row.by_name}}转入团队小煜{{scope.row.score}}</span>
              <span v-if="scope.row.second_type == 7">转出给上级{{scope.row.by_name}}团队小煜{{scope.row.score}}</span>
              <div v-if="scope.row.second_type == 8">
                提现转出团队小煜{{scope.row.score}}:
                <div v-if="scope.row.info_type == 1">银行：<br />银行名称：{{scope.row.bank_name}}<br />开户行：{{scope.row.open_bank}}<br />卡号：{{scope.row.bank_code}}<br />{{scope.row.bank_username}}</div>
                <div v-if="scope.row.info_type == 2">支付宝：<br />真实姓名：{{scope.row.zhi_name}}<br />帐号：{{scope.row.zhi_account}}<br /></div>

              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="create_time_form"
            label="创建时间"
          ></el-table-column>

          <el-table-column
            prop="status"
            label="审核状态"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.status == 2"
                type="success"
                disable-transitions
              >审核成功</el-tag>
              <el-tag
                v-if="scope.row.status == 1"
                disable-transitions
              >审核中</el-tag>
              <el-tag
                v-if="scope.row.status == 3"
                type="danger"
                disable-transitions
              >审核失败</el-tag>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>

    <el-dialog
      title="查看投诉图片"
      :visible.sync="showPicLoading"
      width="40%"
    >
      <div class="shop-pic1">
        <img
          style="width:100%"
          v-for="url in detailPics"
          :key="url"
          :src="url"
        />
      </div>
    </el-dialog>

  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc";
var _ = require("lodash");
export default {
  name: "money_in_list",
  created() {},

  data() {
    return {
      totalMoney: 0,
      listLoading: false,
      picList: [],
      filters: {
        status: null,
        startTime: null,
        title: null,
        userId: null,
        endTime: null,
      },
      page_num: 1,
      keywords: "",
      pickerOptions1: 1,
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      tableHeight: null,
      detailPics: [],
      showPicLoading: false,
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.handleSearch();
  },
  methods: {
    goDetail(row) {
      this.$router.push({
        path: "/score_detail",
        query: { user: JSON.stringify(row) },
      });
    },
    excelOut() {
      var that = this;
      var url =
        "/manager/user/pc/money_in_excel?token=" +
        localStorage.getItem("api_token");
      if (that.filters.status) {
        url = url + "&status=" + that.filters.status;
      }
      if (that.filters.title) {
        url = url + "&username=" + that.filters.title;
      }
      if (that.filters.startTime) {
        url = url + "&startTime=" + that.filters.startTime.getTime();
      }
      if (that.filters.endTime) {
        url = url + "&endTime=" + that.filters.endTime.getTime();
      }
      top.location.href = url;
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    search() {
      let that = this;
      let params = {
        pageNum: that.page_num,
        pageSize: that.page_size,
        scoreType:1,
        token: localStorage.getItem("api_token"),
      };
      if (that.filters.title) {
        params.keywords = that.filters.title;
      }
      if (that.filters.endTime) {
        params.month = dateFunc.formatDate(that.filters.endTime, "yyyy-MM");
      }

      that.listLoading = true;
      API.score_record_list(params)
        .then(
          function (result) {
            that.listLoading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].create_time_form = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                  result.result.list[i].create_time_month = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM"
                  );
                  if (
                    result.result.list[i].other_info != null &&
                    result.result.list[i].other_info != ""
                  ) {
                    result.result.list[i].other_info = JSON.parse(
                      result.result.list[i].other_info
                    );
                  }
                }
              }
              that.tableData = result.result.list;
            }
          },
          function (err) {
            that.listLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000,
            });
          }
        )
        .catch(function (error) {
          that.listLoading = false;
          console.error(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    },
  },
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
.shop-pic1 {
  width: 100%;
  /* display: flex;
    flex-wrap: wrap;
    justify-content: space-around; */
  height: 80vh;
  overflow: hidden;
  overflow-y: auto;
}
.shop-pic1 img {
  /* width: 49%; */
  width: 100%;
  height: auto;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/user/direct_score_list.vue